<template>
  <div :class="classes">
    <pt-sub-title title="视频信息"></pt-sub-title>
    <pt-form-item label="视频名称：" :labelWidth="labelWidth" :required="true">
      <el-input name="base.name" data-vv-as="视频名称" v-validate="'required'" v-model="formData.name" placeholder="请输入视频名称"></el-input>
    </pt-form-item>
    <pt-form-item label="视频封面：" :labelWidth="labelWidth"  :required="true">
      <wt-upload-file accept="image/png,image/jpeg" :action="uploadApi" :data="picture_params" path-url-name="url" :img-url="publicResourcesUrl"
        v-model="formData.imageUrl" :multiple="false" :class="$style['upload-picture']" data-vv-as="封面图" v-validate="'required'">
          <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
      </wt-upload-file>
      <ul :class="$style.pictureNames">
        <li v-for="(item,index) in formData.imageUrl" :key="index">{{item.name}}</li>
      </ul>
      <div :class="$style['upload-tips-text']"  class="gray-color">*建议尺寸：1020*687像素；图片格式：jpg、png</div>
    </pt-form-item>
    <pt-form-item label="上传视频：" :labelWidth="labelWidth" :required="true">
      <pt-upload-big-file resourceConfig="poster" v-model="formData.contentUrl" data-vv-as="视频" v-validate="'required'" @isUpload="isUpload" :isPathUrlAddTime="true" :isPublic="true"></pt-upload-big-file>
    </pt-form-item>
    <pt-form-item label="在工具中心展示：" :labelWidth="labelWidth" :required="true">
      <el-switch v-model="formData.visibleInTools"></el-switch>
    </pt-form-item>
  </div>
</template>

<script>
import ptUploadBigFile from 'cps/base/pt-upload-big-file'
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-video-form'

export default {
  name: 'pt-video-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${this.$style[prefixCls]}`
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  components: { ptUploadBigFile },
  data () {
    return {
      formData: this.value ? this.value : {
        type: 'VIDEO',
        visibleInTools: false
      },
      labelWidth: '150px',
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'poster'
      },
      publicResourcesUrl: this.$publicResourcesUrl
    }
  },
  watch: {
    value (val) {
      // if (val.goodsData) {
      //   this.$set(this, 'goodsData', val.goodsData)
      // }
      this.formData = val
    }
  },
  methods: {
    updateVisible (val) {
      this.showDialog = val
    },
    isUpload (val) {
      this.$emit('isUpload', val)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-video-form{
  :global{
      .form-item .el-input,.el-input__inner{
        max-width: 2.8rem;
      }
      .form-item .el-input--suffix .el-input__inner{
        min-width: 2.8rem;
      }
      .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 270px;
        height: 172px;
      }
      el-textarea,.el-textarea__inner{
        width:500px;
      }
      .wt-upload-file{
        line-height: 0;
        margin-top: 10px;
      }
      .el-upload-list{
        max-width: 800px;
      }
  }
  .pictureNames{
    display: flex;
    margin:0;
    padding-left: 0;
    li{
      width:204px;
      line-height: 20px;
      text-align: center;
    }
  }
  .upload-file-text{
    line-height: 172px;
  }

}

.goods-dialog{
   :global
    .el-dialog{
        width: 70%;
        max-width: 1000px;
    .el-dialog__body{
     padding: 0 20px 30px;
    }
    }
}
</style>
